import { defineComponent as _defineComponent } from 'vue'
import BaseButton from "@/components/buttons/BaseButton.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteButton',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { BaseButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})